import useHelpers from 'hooks/helpers';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import TeamProfileCard from 'components/Tiles/TeamProfileCard';
import { TeamMember } from 'model/TeamMember';

type Props = {
  fields: {
    teamMembers: {
      value: Array<TeamMember>;
    };
  };
  rendering: any;
  showImage: boolean;
};

const TeamProfileBase = ({ fields, rendering, showImage = true }: Props) => {
  const { anchorId } = useHelpers(rendering);
  const teamMembers = fields.teamMembers.value;
  const itemsLength = teamMembers?.length || 0;

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className="container default-section-padding background-white"
    >
      <Placeholder name="abrdn-tiles-heading" rendering={rendering} className="mb-4" />
      <div className="row">
        {teamMembers.map((item) => (
          <TeamProfileCard
            key={item.id}
            fields={item}
            showImage={showImage}
            className={`${
              itemsLength > 3 ? 'col-lg-3' : 'col-lg-4'
            } col-12 col-md-6 mb-4 d-flex flex-column`}
          />
        ))}
      </div>
    </section>
  );
};

export default TeamProfileBase;
